import React, { useEffect } from 'react'

function Modal({show, toggleShow, title, children, className}) {

  const handleCloseModal = () => {
    toggleShow(!show)
  }

  // Escape дарж хаах
  useEffect(() => {
    if (!show) return;
    const onKey = (e) => { if (e.key === 'Escape') handleCloseModal() }
    document.addEventListener('keydown', onKey)
    return () => document.removeEventListener('keydown', onKey)
  }, [show])

  if(!show){
    return null;
  }

  return (
    <div
      className={`fixed top-0 h-full right-0 w-full bg-black/50  flex justify-center items-center z-50`}
      onClick={handleCloseModal}
      role='dialog'
      aria-modal='true'
    >
      <div className='animate-fade-down' onClick={(e) => e.stopPropagation()}>
        <div className={`flex flex-col relative bg-white rounded-md text-black max-h-[40rem] dark:bg-gray-800 dark:text-white ${className && className}`}>
          <button className='absolute flex top-0 right-0 m-3 text-gray-400 hover:text-sky-400 duration-200 rounded-full' type='button' onClick={() => handleCloseModal()} aria-label='Хаах'>
            <ion-icon name="close-circle-outline" size='large' ></ion-icon>
          </button>
          <div className={`h-[52px] px-6 py-3 font-medium text-lg text-slate-500 dark:text-slate-300 border-b`}>{title && title}</div>
          <div className='py-2 px-5 overflow-y-auto'>
            {children}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Modal
